export default "__VITE_ASSET__DpsvtLQw__"